import { useCallback, useEffect, useState } from 'react';
import { Users, Plus, Settings2 } from 'lucide-react';
import { toast } from 'sonner';
import { GroupManagerDialog } from './GroupManagerDialog';

// One-tap saved member lists ("Morning Bootcamp") shown above the member checklist.
export const AssignmentGroupsBar = ({ api, selected, onChange }) => {
  const [groups, setGroups] = useState([]);
  const [dialog, setDialog] = useState(null); // null | 'create' | 'manage'

  const load = useCallback(async () => {
    try {
      const res = await api().get('/admin/assignment-groups');
      setGroups(res.data.groups || []);
    } catch {
      toast.error('Failed to load groups');
    }
  }, [api]);

  useEffect(() => { load(); }, [load]);

  const addGroup = (g) => {
    const merged = [...new Set([...selected, ...g.member_ids])];
    onChange(merged);
    toast.success(`Added ${g.name} (${g.member_ids.length})`);
  };

  return (
    <div className="mb-4" data-testid="assignment-groups-bar">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] uppercase tracking-[0.18em] text-white/50 flex items-center gap-1.5">
          <Users className="h-3.5 w-3.5" /> Groups
        </span>
        {groups.length > 0 && (
          <button type="button" onClick={() => setDialog('manage')} className="text-xs text-white/60 hover:text-primary inline-flex items-center gap-1" data-testid="manage-groups-btn">
            <Settings2 className="h-3.5 w-3.5" /> Manage
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {groups.map((g) => {
          const allIn = g.member_ids.length > 0 && g.member_ids.every((id) => selected.includes(id));
          return (
            <button
              type="button" key={g.id} onClick={() => addGroup(g)}
              className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${allIn ? 'bg-primary text-black border-primary' : 'bg-white/[0.05] text-white border-white/15 hover:border-primary/60'}`}
              data-testid={`group-pill-${g.id}`}
            >
              {g.name} <span className={allIn ? 'text-black/60' : 'text-white/40'}>· {g.member_ids.length}</span>
            </button>
          );
        })}
        <button
          type="button" onClick={() => setDialog('create')} disabled={!selected.length}
          className="px-3 py-1.5 rounded-full text-xs border border-dashed border-primary/50 text-primary inline-flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="save-selection-as-group-btn"
        >
          <Plus className="h-3 w-3" /> Save selection as group
        </button>
      </div>
      <GroupManagerDialog
        mode={dialog} onClose={() => setDialog(null)} api={api}
        groups={groups} selected={selected} onSaved={load}
      />
    </div>
  );
};

export default AssignmentGroupsBar;
